import React from "react";
import { Modal } from "react-bootstrap";

export default function MyModal(props) {
  const handleClose = () => props.onHide && props.onHide();

  return (
    <Modal show={props.isOpen} onHide={handleClose}>
      <Modal.Header
        className="bg-button-color"
        closeButton={!props.closeButton ? props.closeButton : true}
      />
      <Modal.Body className="h-300">{props.body}</Modal.Body>
      <Modal.Footer className="justify-content-center">
        {props.footer}
      </Modal.Footer>
    </Modal>
  );
}
